(function(){
  'use strict';

  function q(root,sel){return (root||document).querySelector(sel);}
  function qa(root,sel){return Array.prototype.slice.call((root||document).querySelectorAll(sel));}
  function desktop(){return window.matchMedia ? window.matchMedia('(min-width:1025px)').matches : window.innerWidth>=1025;}

  function openFinance(root){
    qa(root||document,'[data-lbx-finance-card]').forEach(function(card){
      var controls=q(card,'[data-lbx-finance-controls]');
      var toggle=q(card,'[data-lbx-finance-toggle]');
      if(controls){controls.hidden=false;controls.removeAttribute('hidden');}
      card.classList.add('is-open');
      if(toggle)toggle.setAttribute('aria-expanded','true');
    });
  }

  function initStoreHover(root){
    if(!desktop())return;
    qa(root||document,'[data-lbx-stock-hub]').forEach(function(hub){
      if(hub.dataset.lbx99StockReady==='1')return;
      hub.dataset.lbx99StockReady='1';
      var fast=q(hub,'[data-lbx-fast-stock]');
      var panel=q(hub,'[data-lbx-store-stock-panel]');
      if(!fast||!panel)return;
      fast.setAttribute('tabindex','0');
      fast.setAttribute('aria-haspopup','true');
      var closeTimer=0;
      function eligible(){return panel.getAttribute('data-lbx-store-eligible')==='true' && !panel.hidden;}
      function position(){
        var top=fast.offsetTop+fast.offsetHeight+8;
        panel.style.setProperty('--lbx99-stock-top',top+'px');
      }
      function open(){
        if(!eligible())return;
        window.clearTimeout(closeTimer);
        position();
        hub.classList.add('is-lbx99-stock-open');
        fast.setAttribute('aria-expanded','true');
      }
      function close(){
        window.clearTimeout(closeTimer);
        closeTimer=window.setTimeout(function(){
          if(hub.matches(':hover')||hub.contains(document.activeElement))return;
          hub.classList.remove('is-lbx99-stock-open');
          fast.setAttribute('aria-expanded','false');
        },100);
      }
      fast.addEventListener('mouseenter',open);
      fast.addEventListener('focus',open);
      hub.addEventListener('mouseleave',close);
      hub.addEventListener('focusout',close);
      fast.addEventListener('click',function(e){
        if(!eligible())return;
        e.preventDefault();
        if(hub.classList.contains('is-lbx99-stock-open')){
          hub.classList.remove('is-lbx99-stock-open');
          fast.setAttribute('aria-expanded','false');
        }else open();
      });
      if('ResizeObserver' in window){
        var ro=new ResizeObserver(function(){if(hub.classList.contains('is-lbx99-stock-open'))position();});
        ro.observe(fast);
      }
    });
  }

  function init(){
    openFinance(document);
    initStoreHover(document);
    /* Old finance-close helpers can run a little later than the product core.
       Re-assert the requested default open state once, without observers. */
    window.setTimeout(function(){openFinance(document);initStoreHover(document);},220);
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  window.addEventListener('load',function(){openFinance(document);initStoreHover(document);},{once:true});
  document.addEventListener('shopify:section:load',function(e){openFinance(e.target||document);initStoreHover(e.target||document);});
})();
